<style lang="scss" scoped>
.PreviewCustomer {
  width: 375px;
  height: 705px;

  box-sizing: border-box;

  img {
    width: 100%;
  }
  .box {
    padding: 85px 25px 0 25px;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
}
</style>
<template>
  <div class="PreviewCustomer">
    <div
      class="box"
      :style="{ 'background-image': `url(${backgroundImg || `../../assets/img/u9.png`})` }"
    >
      <img
        :src="require('@/assets/img/guideShopshelf/card.png')"
        alt=""
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewCustomer',
  props: {
    backgroundImg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showImgPicker: false
    }
  },
  created () {},
  methods: {
    handleClickChangeImage () {
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        this.value.img = data[0].image_url
      }
      this.$emit('input', this.value)
    }
  }
}
</script>
